import * as TREE_ACTIONS from '../redux/actions/tree-action';
import { changeTreeLeaf } from '../utils';

const state = {
    isEditing: false,
    nodeSelected: null,
    infoPages: [],
    selectedInfoPage: null,
    tree: [],
    copyData: null,
    mainNodeId: '',
    countLatestVersion: 0,
    selectedInfoPageLang: null,
    saveInfoPage: {
        status: null,
        id: '',
    },
    isDirty: false
};

export default (previousState = state, { type, payload }) => {
    switch (type) {
        case TREE_ACTIONS.RESET_INFO_PAGE:
            return state;
        case TREE_ACTIONS.CHANGE_INFO_PAGES:
            return {
                ...previousState,
                infoPages: payload
            };
        case TREE_ACTIONS.TOGGLE_EDIT:
            return {
                ...previousState,
                isEditing: payload
            };
        case TREE_ACTIONS.SELECT_NODE:
            return {
                ...previousState,
                nodeSelected: payload
            };
        case TREE_ACTIONS.SELECT_INFO_PAGE:
            return {
                ...previousState,
                selectedInfoPage: payload,
                isDirty: false
            };
        case TREE_ACTIONS.CHANGE_TREE_DATA:
            return {
                ...previousState,
                tree: payload
            };
        case TREE_ACTIONS.COPY_DATA:
            return {
                ...previousState,
                copyData: payload
            };
        case TREE_ACTIONS.CHANGE_MEDIA_GRID:
            return {
                ...previousState,
                node: {
                    ...previousState.node,
                    nodeApplication: {
                        ...previousState.node.nodeApplication,
                        mediaGrid: payload
                    }
                }
            };
        case TREE_ACTIONS.CHANGE_NODE_MAIN_DATA:
            var newNode = {
                ...previousState.nodeSelected,
                data: payload.data
            };
            var newTree = previousState.tree.map(item => {
                if (item.children[0].id === payload.id) {
                    const mainNode = { ...item };
                    mainNode.children[0].data = payload.data;
                    return mainNode;
                }
                return item;
            });
            return {
                ...previousState,
                nodeSelected: newNode,
                tree: newTree,
            };
        case TREE_ACTIONS.CHANGE_NODE_GLOBAL_DATA:
            if (payload.nodeSelectedId !== -1) {
                if (previousState.nodeSelected.id === payload.nodeSelectedId) {
                    return {
                        ...previousState,
                        nodeSelected: {
                            ...previousState.nodeSelected,
                            applicationData: payload.data
                        },
                        isDirty: payload.isDirty
                    };
                }
            } else {
                return {
                    ...previousState,
                    nodeSelected: {
                        ...previousState.nodeSelected,
                        applicationData: payload.data
                    },
                    tree: changeTreeLeaf(previousState.tree, previousState.nodeSelected.id, payload.data),
                    isDirty: payload.isDirty
                };
            }
        case TREE_ACTIONS.MAIN_NODE_ID:
            return {
                ...previousState,
                mainNodeId: payload
            };
        case TREE_ACTIONS.CHANGE_COUNT_LATEST_VERSION:
            return {
                ...previousState,
                countLatestVersion: payload
            };
        case TREE_ACTIONS.INCREASE_COUNT_LATEST_VERSION:
            return {
                ...previousState,
                countLatestVersion: previousState.countLatestVersion + 1
            };
        case TREE_ACTIONS.CHANGE_SELECTED_INFO_LANG:
            return {
                ...previousState,
                selectedInfoPageLang: payload
            };
        case TREE_ACTIONS.SAVE_INFO_PAGE:
            return {
                ...previousState,
                saveInfoPage: payload
            };
        case TREE_ACTIONS.CHANGE_DIRTY_STATUS:
            return {
                ...previousState,
                isDirty: payload
            };
        default:
            break;
    }
    return previousState;
};
